import React from 'react';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import InsightsIcon from '@mui/icons-material/Insights';
import HomeCard from '../shared/HomeCard';
import { useAuth } from '../context/AuthContext';
import { categories } from '../config/categories';
import { getSundargarhCategoryRuleCounts } from '../config/sundargarhRules';

// Sundargarh counterpart of MainDashboard.js — same Explore + Validation
// Rules layout, but "Explore" points at the live-KoboToolbox dashboard and
// the rule categories point at the Sundargarh-scored versions of each rule.
export default function SundargarhHub() {
  const { user } = useAuth();

  return (
    <div className="page">
      {!user?.district && (
        <Link to="/" className="back-link">
          <ArrowBackIcon fontSize="small" /> Back to Home
        </Link>
      )}
      <div className="home-hero">
        <h1>Welcome{user?.name ? `, ${user.name}` : ''}</h1>
        <p>Live Sundargarh survey data and validation-rule categories, pulled directly from KoboToolbox.</p>
      </div>

      <section className="home-section">
        <h2 className="home-section-title">Explore</h2>
        <div className="card-grid">
          <HomeCard
            to="/sundargarh-dashboard"
            title="Sundargarh Dashboard"
            description="Live survey KPIs, time/household/children stats and the records table — filterable by ULB, Ward and Enumerator."
            icon={LocationCityIcon}
            accent="var(--primary)"
          />
          <HomeCard
            to="/sundargarh-analytics"
            title="Sundargarh Analytics"
            description="Live group-by statistics — duration, household members, children — across Enumerator, ULB and Ward."
            icon={InsightsIcon}
            accent="var(--cat-gender)"
          />
        </div>
      </section>

      <section className="home-section">
        <h2 className="home-section-title">Validation Rules</h2>
        <div className="card-grid">
          {categories.map((cat) => {
            const { total, available } = getSundargarhCategoryRuleCounts(cat.id);
            return (
              <HomeCard
                key={cat.id}
                to={`/sundargarh-category/${cat.id}`}
                title={cat.label}
                description={cat.description}
                icon={cat.icon}
                accent={cat.accent}
                badge={`${available} of ${total} available`}
              />
            );
          })}
        </div>
      </section>
    </div>
  );
}
